'use strict'; //
//

exports.__esModule = true;
exports.default = void 0;

require("./icon.less");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireDefault(require("../core/component"));

var _enhance = _interopRequireDefault(require("../core/enhance"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

//
var colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#8BC34A', '#CDDC39', '#FFEB3B', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B'];
/**
 * 字体图标
 */

var Icon = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Icon, _Component);

  function Icon(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {};

    _this.renderPrefix = function () {
      return _this.props.type || Icon.type || 'iconfont';
    };

    return _this;
  }

  var _proto = Icon.prototype;

  _proto.renderStyle = function renderStyle(icon) {
    if (this.props.hashColor) {
      return {
        color: colors[icon.hashCode() % colors.length]
      };
    }
  };

  _proto.render = function render() {
    if (!this.props.icon) return null;

    if (this.props.symbol) {
      var name = this.renderPrefix() + "-" + this.props.icon;
      return /*#__PURE__*/_react.default.createElement("svg", {
        className: (0, _classnames.default)('c-icon', this.renderPrefix(), this.props.className)
      }, /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#" + name
      }));
    } else {
      var Elem = this.props.elem || 'i';
      var icon = this.props.icon;
      return /*#__PURE__*/_react.default.createElement(Elem, {
        className: (0, _classnames.default)(this.renderPrefix(), this.renderPrefix() + "-" + icon, '', 'c-icon', this.props.className),
        style: this.props.style,
        onClick: this.props.onClick
      });
    }
  };

  return Icon;
}(_component.default);

Icon.type = "iconfont";
Icon.displayName = "Icon"; //Enhance(Icon, {}, 'Icon');

var _default = Icon;
exports.default = _default;
module.exports = exports.default;